<div class="imagenCompleta__panel" *ngIf="abierto || abiertaPrimeraVes" [hidden]="!abierto">

  <div class="imagenCompleta__panel__backdrop" (click)="CerrarModal()"></div>

  <div class="imagenCompleta__panel__imagen animated {{animacion}}" [hidden]="!cargada" (click)="ClickImagenContainer($event)">
    <img [src]="imagen" [ngClass]="{'imagenCompleta__panel__imagen--portrait': alto > ancho}" (load)="ImagenCargada($event)" #imagenCompleta/>
  </div>

  <div class="imagenCompleta__panel__times" (click)="CerrarModal()">
    <div class="imagenCompleta__panel__times__boton">
      <span class="fa fa-times"></span>
    </div>
  </div>

</div>
